module.exports = __webpack_public_path__ + "img/logo.a33c4b52.png";